/**
 * Mirrors the Prisma enums (backend/prisma/schema.prisma) as const objects, so the frontend gets
 * typed, string-identical values without depending on the generated Prisma client. Kept in sync
 * by hand.
 */

export const StoreRole = { OWNER: 'OWNER', CLIENT: 'CLIENT' } as const;
export type StoreRole = (typeof StoreRole)[keyof typeof StoreRole];

export const MemberStatus = { PENDING: 'PENDING', APPROVED: 'APPROVED', REJECTED: 'REJECTED' } as const;
export type MemberStatus = (typeof MemberStatus)[keyof typeof MemberStatus];

export const JoinRequestStatus = { PENDING: 'PENDING', APPROVED: 'APPROVED', REJECTED: 'REJECTED' } as const;
export type JoinRequestStatus = (typeof JoinRequestStatus)[keyof typeof JoinRequestStatus];

export const DocumentType = {
  PURCHASE: 'PURCHASE',
  SALE: 'SALE',
  RETURN_IN: 'RETURN_IN',
  RETURN_OUT: 'RETURN_OUT',
  WRITE_OFF: 'WRITE_OFF',
  INVENTORY: 'INVENTORY',
} as const;
export type DocumentType = (typeof DocumentType)[keyof typeof DocumentType];

export const DocumentStatus = { DRAFT: 'DRAFT', POSTED: 'POSTED', CANCELLED: 'CANCELLED' } as const;
export type DocumentStatus = (typeof DocumentStatus)[keyof typeof DocumentStatus];

export const PaymentStatus = { UNPAID: 'UNPAID', PARTIAL: 'PARTIAL', PAID: 'PAID' } as const;
export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus];

export const WriteOffReason = {
  SPOILAGE: 'SPOILAGE',
  EXPIRED: 'EXPIRED',
  SHORTAGE: 'SHORTAGE',
  DEFECT: 'DEFECT',
  OTHER: 'OTHER',
} as const;
export type WriteOffReason = (typeof WriteOffReason)[keyof typeof WriteOffReason];

export const BatchSource = { PURCHASE: 'PURCHASE', RETURN_IN: 'RETURN_IN', INVENTORY: 'INVENTORY' } as const;
export type BatchSource = (typeof BatchSource)[keyof typeof BatchSource];

export const PaymentType = { PAYMENT: 'PAYMENT', OFFSET: 'OFFSET', REFUND: 'REFUND' } as const;
export type PaymentType = (typeof PaymentType)[keyof typeof PaymentType];

export const PaymentDirection = { IN: 'IN', OUT: 'OUT' } as const;
export type PaymentDirection = (typeof PaymentDirection)[keyof typeof PaymentDirection];

export const PaymentMethod = { CASH: 'CASH', CASHLESS: 'CASHLESS', TRANSFER: 'TRANSFER' } as const;
export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod];

export const LedgerSource = { DOCUMENT: 'DOCUMENT', PAYMENT: 'PAYMENT' } as const;
export type LedgerSource = (typeof LedgerSource)[keyof typeof LedgerSource];

export const OrderRequestStatus = {
  NEW: 'NEW',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  DONE: 'DONE',
} as const;
export type OrderRequestStatus = (typeof OrderRequestStatus)[keyof typeof OrderRequestStatus];

export const AuditEventType = {
  DOCUMENT_CREATED: 'DOCUMENT_CREATED',
  DOCUMENT_UPDATED: 'DOCUMENT_UPDATED',
  DOCUMENT_POSTED: 'DOCUMENT_POSTED',
  DOCUMENT_UNPOSTED: 'DOCUMENT_UNPOSTED',
  DOCUMENT_CANCELLED: 'DOCUMENT_CANCELLED',
  DOCUMENT_RETURNED_TO_DRAFT: 'DOCUMENT_RETURNED_TO_DRAFT',
  DOCUMENT_DELETED: 'DOCUMENT_DELETED',
  DOCUMENT_RESTORED: 'DOCUMENT_RESTORED',
  PAYMENT_CREATED: 'PAYMENT_CREATED',
  PAYMENT_UPDATED: 'PAYMENT_UPDATED',
  PAYMENT_REALLOCATED: 'PAYMENT_REALLOCATED',
  PAYMENT_DELETED: 'PAYMENT_DELETED',
  CATEGORY_RENAMED: 'CATEGORY_RENAMED',
  CATEGORY_MOVED: 'CATEGORY_MOVED',
  WHOLESALE_PRICE_CHANGED: 'WHOLESALE_PRICE_CHANGED',
  CATEGORY_PCS_PER_BOX_CHANGED: 'CATEGORY_PCS_PER_BOX_CHANGED',
  COUNTERPARTIES_MERGED: 'COUNTERPARTIES_MERGED',
  PASSWORD_RESET: 'PASSWORD_RESET',
} as const;
export type AuditEventType = (typeof AuditEventType)[keyof typeof AuditEventType];

/** Не хранится в БД напрямую как enum поля документа — используется в UI/DTO для предупреждений (§1, §5, §8.1, §11, §12.6). */
export const LineWarning = {
  STOCK_NEGATIVE: 'STOCK_NEGATIVE',
  PCS_PER_BOX_DIFFERS: 'PCS_PER_BOX_DIFFERS',
  OVER_BASE: 'OVER_BASE',
  NO_BASE: 'NO_BASE',
  ARCHIVED_CATEGORY: 'ARCHIVED_CATEGORY',
  COUNTERPARTY_ARCHIVED: 'COUNTERPARTY_ARCHIVED',
  PROVISIONAL_COST: 'PROVISIONAL_COST',
  NO_PURCHASE_PRICE: 'NO_PURCHASE_PRICE',
} as const;
export type LineWarning = (typeof LineWarning)[keyof typeof LineWarning];
